module.exports = __webpack_public_path__ + "img/intro_no.cc63424a.svg";